import { isAxiosError } from '@/portainer/services/axios/utils/isAxiosError';

export function resolveLicenseError(
  err: unknown,
  defaultMessage: string
): string {
  if (isAxiosError<{ message?: string }>(err) && err.response?.status === 402) {
    return err.response.data?.message ?? 'License limit exceeded';
  }
  return defaultMessage;
}
